import styled from "styled-components";

export const Loader = styled.iframe`
    width: 100%;
    height: 800px;
`;